import React, { useState } from "react";
import TitleUnderlined from "../components/TitleUnderlined";
import Button from "../components/Button";
import Order from "../models/Order";
import Utils from "../tools/Utils";
import { useParams } from 'react-router';

const ThanksView = () => {
    const { obj } = useParams();
    const [order] = useState(Order.fromJson(JSON.parse(Utils.decodeBase64(obj))));

    return (
        <div className="pt-5 pb-5" id="paymentView">
            <br></br>
            <br></br>
            <TitleUnderlined> ¡Todos somos Almas en <span className="embercom_overlined">Salida!</span></TitleUnderlined>
            <br></br>
            <br></br>
            <br></br>
            <h3>¡Tu inscripción ha sido exitosa!</h3>
            <p>A continuación encontraras los códigos de barras de tus boletos con los accesos de cada visitante adjuntos. <br /><br /> Es importante que mantengan estos códigos de manera confidencial. <br /><br /> Lo esperamos el siguiente 29 de agosto de 2026 a las 09:00 hrs(7:30am ingreso) para su registro con el código de barras de su boleto. <br /><br /> <strong>Favor de traer a la mano sus boletos impresos o legibles en su teléfono móvil.</strong></p>
            <br></br>
            <a href={`${process.env.REACT_APP_API_URL}/boletos/${order.orderId}`} style={{color:'#000',textDecoration:'none'}} target="_blank" rel="noreferrer">
                <Button style={{padding: '1rem 1.5rem'}}>Descargar boletos en PDF <img src={require('../assets/download.png')} alt="downloadIcon" style={{marginLeft: '10px',width: '25px',height:'25px',maxHeight:'25px'}} /></Button>
            </a>
        </div>
    )
}

export default ThanksView;